/*
 * Неразрывный пробел. Применять в случае, когда нет возможности явно использовать html special symbol, либо он не интерпретируется за спец символ и выводится строкой
 */
export const NBSP = String.fromCharCode(160);
export const RubleSymbol = String.fromCharCode(8381);
export const MDASH = String.fromCharCode(8212);
export const NBHYPHEN = String.fromCharCode(8209);
export const LAQUO = String.fromCharCode(171);
export const RAQUO = String.fromCharCode(187);
